export default "__VITE_ASSET__y0J3nQW8__"